/** @module SiteAdmin/Lookup/NewLookupItem */
define([
	"dojo/_base/declare",
	"csi",
	"csi/table/New"
], function(declare,csi,New) {

	return declare(New, {
		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: fix type based on switchboard
			if (this.widget.urlSubtype != csi.EMPTY_URL) {
				view.addFixedValue("Subtype", this.widget.urlSubtype);
			}

			this.inherited(arguments);
		}
	});
});